import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import DatePicker from 'material-ui/DatePicker';
import { GrayButton, SecondaryButton, Spinner } from 'components';
import styles from './ClientDetailForm.scss';
var ClientDetailForm = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ClientDetailForm, _Component);

  var _super = _createSuper(ClientDetailForm);

  function ClientDetailForm() {
    var _this;

    _classCallCheck(this, ClientDetailForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var val = e.target.value;
      var fieldName = e.target.id;

      _this.props.handleFormFieldChange(fieldName, val);
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (fieldName, value, hintText, floatingLabelText, width) {
      floatingLabelText = typeof floatingLabelText === 'undefined' ? hintText : floatingLabelText;
      width = typeof width === 'undefined' ? '100%' : width;
      return /*#__PURE__*/React.createElement(TextField, {
        hintText: hintText,
        floatingLabelText: floatingLabelText,
        id: fieldName,
        value: value,
        onChange: _this.handleChange,
        style: {
          width: width
        }
      });
    });

    return _this;
  }

  _createClass(ClientDetailForm, [{
    key: "render",
    value: function render() {
      var formValues = this.props.formValues;
      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.sectionHeader
      }, "Customer Details"), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginBottom: 40
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderInput('organizationName', formValues.organizationName, 'Business Name')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, this.renderInput('ownerFirstName', formValues.ownerFirstName, 'Owner First Name')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, this.renderInput('ownerLastName', formValues.ownerLastName, 'Owner Last Name')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderInput('email', formValues.email, 'Email')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderInput('phone', formValues.phone, 'Phone')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, this.renderInput('address1', formValues.address1, 'Address Line 1')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, this.renderInput('address2', formValues.address2, 'Address Line 2')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, this.renderInput('locality', formValues.locality, 'City')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, this.renderInput('region', formValues.region, 'State')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, this.renderInput('postcode', formValues.postcode, 'Zip Code'))));
    }
  }]);

  return ClientDetailForm;
}(Component)) || _class);
export default ClientDetailForm;